exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-v-2633569c] .md-error {\r\n    padding-top: 15px !important;\n}\r\n", ""]);

// exports
